module.exports = __webpack_public_path__ + "static/media/Zed.58968b37.png";